import { ipCountryQuery } from '@gig/magic-common';
import { __awaiter, __generator } from 'tslib';
import { Currency } from '@gig/magic-sdk/dist/adapter/users/signup';
import { Country } from '@gig/magic-sdk/dist/adapter/users/getCountries';

function getCountries() {
    return __awaiter(this, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = {
                        countries: [
                            {
                                code: Country.MALTA,
                                name: 'Malta',
                                phonePrefix: '+356',
                                currency: Currency.EUR,
                                legalAge: 18,
                            },
                            {
                                code: Country.PHILIPPINES,
                                name: 'Philippines',
                                phonePrefix: '+63',
                                currency: Currency.PHP,
                                legalAge: 21,
                            },
                            {
                                code: Country.SPAIN,
                                name: 'Spain',
                                phonePrefix: '+34',
                                currency: Currency.EUR,
                                legalAge: 18,
                            },
                            {
                                code: Country.UNITED_KINGDOM,
                                name: 'United Kingdom',
                                phonePrefix: '+44',
                                currency: Currency.GBP,
                                legalAge: 18,
                            },
                            {
                                code: Country.UNITED_STATES,
                                name: 'United States',
                                phonePrefix: '+1',
                                currency: Currency.USD,
                                legalAge: 18,
                            },
                        ]
                    };
                    return [4 /*yield*/, ipCountryQuery()];
                case 1: return [2 /*return*/, (_a.currentIPCountry = _b.sent(),
                        _a)];
            }
        });
    });
}

export { getCountries };
